import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { prayerTimesActions } from "../../Redux";
import {
  getConfigurationState,
  getPrayerTimesState,
} from "../../Redux/GetState";
import { addDays, addMinutes, getPrayerTime, SlideType } from "../Helpers";
import { IPrayerInProgress } from "./IPrayerInProgress";
import "./Style.css";

export const PrayerInProgress: React.FC<IPrayerInProgress> = (
  props: IPrayerInProgress,
): JSX.Element => {
  const { prayerTimes } = useSelector(getPrayerTimesState);
  const { configuration } = useSelector(getConfigurationState);

  const [date, setDate] = useState(new Date());
  const [doZikar, setDoZikar] = useState(false);
  const [prayerStarted, setPrayerStarted] = useState(false);
  const [iftarStarted, setIftarStarted] = useState(false);
  const [isInTarawee, setIsInTarawee] = useState(false);
  const [holdDuration, setHoldDuration] = useState(new Date());

  const dispatch = useDispatch();

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const toDate = (value: string | Date): Date =>
    value instanceof Date ? value : new Date(value);

  function clearMessages() {
    setDoZikar(false);
    setPrayerStarted(false);
    setIftarStarted(false);
    setIsInTarawee(false);
  }

  function IsFiveMinToPrayer(prayerTime: Date): boolean {
    const time = date.getTime();

    return (
      time > addMinutes(prayerTime, -5).getTime() && time < prayerTime.getTime()
    );
  }

  function IsPrayerInProgress() {
    const today = getPrayerTime(prayerTimes, props.dateTime.getDate());
    const tomorrow = getPrayerTime(prayerTimes, addDays(date, 1).getDate());

    clearMessages();

    if (!today || !tomorrow) return;

    const prayerPause = 6;
    const totalPause = 10;

    const JumatFajar = toDate(today.JumatFajar);
    const JumatZohar = toDate(today.JumatZohar);
    const JumatAsar = toDate(today.JumatAsar);
    const StartMaghrib = toDate(today.StartMaghrib);
    const JumatMaghrib = toDate(today.JumatMaghrib);
    const JumatIsha = toDate(today.JumatIsha);

    const Jumaah1 = today.Jumaah1 ? toDate(today.Jumaah1) : undefined;
    const Jumaah2 = today.Jumaah2 ? toDate(today.Jumaah2) : undefined;
    const Jumaah3 = today.Jumaah3 ? toDate(today.Jumaah3) : undefined;

    const fajarPauseTime = addMinutes(JumatFajar, prayerPause);
    const zoharPauseTime = addMinutes(JumatZohar, prayerPause);
    const asarPauseTime = addMinutes(JumatAsar, prayerPause);
    const maghribPauseTime = addMinutes(JumatMaghrib, prayerPause);

    let ishaPauseTime = addMinutes(JumatIsha, prayerPause);

    if (tomorrow.IsRamadanDay) {
      ishaPauseTime = addMinutes(JumatIsha, 60);
    }

    const startMaghribPauseTime = addMinutes(StartMaghrib, 4);

    let beforePrayer =
      IsFiveMinToPrayer(JumatFajar) ||
      IsFiveMinToPrayer(JumatZohar) ||
      IsFiveMinToPrayer(JumatAsar) ||
      IsFiveMinToPrayer(StartMaghrib) ||
      IsFiveMinToPrayer(JumatMaghrib) ||
      IsFiveMinToPrayer(JumatIsha);

    const day = days[date.getDay()];

    if (Jumaah1 && IsFiveMinToPrayer(Jumaah1)) {
      beforePrayer = true;
    }

    if (Jumaah2 && IsFiveMinToPrayer(Jumaah2)) {
      beforePrayer = true;
    }

    if (Jumaah3 && IsFiveMinToPrayer(Jumaah3)) {
      beforePrayer = true;
    }

    if (date > JumatFajar && date < fajarPauseTime) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(JumatFajar, totalPause));
      setPrayerStarted(true);
    } else if (date > JumatZohar && date < zoharPauseTime) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(JumatZohar, totalPause));
      setPrayerStarted(true);
    } else if (date > JumatAsar && date < asarPauseTime) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(JumatAsar, totalPause));
      setPrayerStarted(true);
    } else if (
      today.IsRamadanDay &&
      date > StartMaghrib &&
      date < startMaghribPauseTime
    ) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(StartMaghrib, 4));
      setIftarStarted(true);
    } else if (date > JumatMaghrib && date < maghribPauseTime) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(JumatMaghrib, totalPause));
      setPrayerStarted(true);
    } else if (today.IsRamadanDay && date > JumatIsha && date < ishaPauseTime) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(JumatIsha, totalPause));
      setIsInTarawee(true);
    } else if (date > JumatIsha && date < ishaPauseTime) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(JumatIsha, totalPause));
      setPrayerStarted(true);
    } else if (
      day === "Friday" &&
      Jumaah1 &&
      date > Jumaah1 &&
      date < addMinutes(Jumaah1, 15)
    ) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(Jumaah1, 15));
      setPrayerStarted(true);
    } else if (
      day === "Friday" &&
      Jumaah2 &&
      date > Jumaah2 &&
      date < addMinutes(Jumaah2, 15)
    ) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(Jumaah2, 15));
      setPrayerStarted(true);
    } else if (
      day === "Friday" &&
      Jumaah3 &&
      date > Jumaah3 &&
      date < addMinutes(Jumaah3, 15)
    ) {
      dispatch(prayerTimesActions.setSlide(SlideType.ShowPrayerInProgress));
      setHoldDuration(addMinutes(Jumaah3, 15));
      setPrayerStarted(true);
    } else if (date < holdDuration) {
      dispatch(prayerTimesActions.setSlide(SlideType.DisplayTime));
    } else if (beforePrayer) {
      dispatch(prayerTimesActions.setSlide(SlideType.DisplayTime));
    } else {
      dispatch(prayerTimesActions.setSlide(SlideType.Loop));
      setDoZikar(true);
    }
  }

  useEffect(() => {
    setDate(props.dateTime);
    IsPrayerInProgress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dateTime]);

  const infoContent = (): JSX.Element => (
    <div>
      <div dangerouslySetInnerHTML={{ __html: configuration.Slide2 }} />
    </div>
  );

  const prayerInProgressContent = (): JSX.Element => (
    <div className="progress-colour">Prayer in progress</div>
  );

  const showIftar = (): JSX.Element => (
    <div className="iftar-colour">
      Iftar time
      <br />
      <br />
      اَللّٰهُمَّ اِنَّی لَکَ صُمْتُ وَبِکَ اٰمَنْتُ وَعَلَيْکَ تَوَکَّلْتُ
      وَعَلٰی رِزْقِکَ اَفْطَرْتُ.
      <br />
      <br />
      <br />O Allah! I fasted for you and I believe in you and I put my trust in
      You and I break my fast with your sustenance.
    </div>
  );

  const inTarawee = (): JSX.Element => (
    <div className="tarawee-colour">
      Taraweeh Dua
      <br />
      <br />
      سُبْحَانَ ذِی الْمُلْکِ وَالْمَلَکُوْتِ ط سُبْحَانَ ذِی الْعِزَّةِ
      وَالْعَظَمَةِ وَالْهَيْبَةِ وَالْقُدْرَةِ وَالْکِبْرِيَآئِ وَالْجَبَرُوْتِ
      ط سُبْحَانَ الْمَلِکِ الْحَيِ الَّذِی لَا يَنَامُ وَلَا يَمُوْتُ سُبُّوحٌ
      قُدُّوْسٌ رَبُّنَا وَرَبُّ الْمَلَائِکَةِ وَالرُّوْحِ ط اَللّٰهُمَّ
      اَجِرْنَا مِنَ النَّارِ يَا مُجِيْرُ يَا مُجِيْرُ يَا مُجِيْر۔
    </div>
  );

  return (
    <div>
      <table>
        <tbody>
          <tr>
            <td>
              {doZikar && infoContent()}
              {prayerStarted && prayerInProgressContent()}
              {iftarStarted && showIftar()}
              {isInTarawee && inTarawee()}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
